import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
} from 'recompose';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import ItemAutocomplete from 'components/ItemAutocomplete';
import { withStyles } from '@material-ui/core/styles';
import {
  dispatchRestMaker,
} from 'helpers/utils';
import goodActions from 'redux/goods/actions';
import contactActions from 'redux/contacts/actions';
import {
  selectState,
} from 'redux/selectors';
import storeActions from 'redux/storeItems/actions';
import ordersActions from 'redux/orders/actions';
import { FRInput } from 'elements';
import { Grid, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const styles = theme => ({
  dialog: {
    [theme.breakpoints.up('sm')]: {
      width: 700,
    },
  },
  dialogActions: {
    [theme.breakpoints.up('sm')]: {
      margin: '8px 24px 24px',
    },
  },
  inputType: {
    height: 0,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500],
  },
  cancelBtn: {
    textTransform: 'capitalize',
  },
  addItemBtn: {
    backgroundColor: '#5CC044',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: '#5CC044',
    },
  },
});

class AddItemToOrderModal extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
    isFarmer: PropTypes.bool,
    setHotNotification: PropTypes.func.isRequired,
  };

  static propTypes = {
    open: PropTypes.bool,
    classes: PropTypes.shape({}).isRequired,
    handleClose: PropTypes.func.isRequired,
    handleAddItem: PropTypes.func.isRequired,
    listGoodItems: PropTypes.func,
    listStoreItems: PropTypes.func,
    updateOrder: PropTypes.func.isRequired,
    readOrder: PropTypes.func.isRequired,
  };

  static defaultProps = {
    open: false,
  };

  state = {
    selectedItem: null,
    items: [],
  }

  componentWillMount() {
    const { isFarmer, currentUser } = this.context;
    const { listStoreItems, listGoodItems } = this.props;
    if (isFarmer) {
      listStoreItems();
    } else {
      listGoodItems({ sellerAccountId: isFarmer ? currentUser.account.id : null});
    }
  }

  getDataWithoutFilter = ({
    details,
    isFarm,
  }) => {
    const data = [];
    const { currentUser } = this.context;

    if (details) {
      details.forEach((itemInfo) => {
        if (!isFarm) {
          if (!itemInfo.approved || (itemInfo.productData.approved === false
            && itemInfo.storeItemId)) {
            return;
          }
        }

        if (itemInfo.productData.approved === false && itemInfo.storeItemId) {
          return;
        }

        if (isFarm && itemInfo.approved === false) {
          return;
        }

        const availableQuantity = itemInfo.packrows.length > 0 ? itemInfo.packrows[0].availableQuantity : 0;
        if (parseFloat(availableQuantity || 0, 10) <= 0) {
          return;
        }

        const price = itemInfo.packrows.length > 0 ? itemInfo.packrows[0].price : 0;
        const originCompanyName = currentUser.account.profile.companyName || '';
        data.push({
          ...itemInfo,
          sourcename: !isFarm ? (itemInfo.seller.companyName || originCompanyName) : originCompanyName,
          availableQuantity,
          price,
          isBulk: itemInfo.packrows[0].isBulk,
        });
      });
    }

    return data;
  }

  handleAddItem = (item) => {
    const { isFarmer } = this.context;
    const items = [];
    if (item.isBulk) {
      item.packrows.forEach((packrow) => {
        items.push({
          goodId: isFarmer ? null : item.id,
          packrow: {
            ...packrow,
          },
          quantity: 0,
          storeItemId: isFarmer ? item.id : null,
        });
      });
    } else {
      items.push({
        goodId: isFarmer ? null : item.id,
        packrow: {
          ...item.packrows[0],
        },
        quantity: 0,
        storeItemId: isFarmer ? item.id : null,
      });
    }
    this.setState({ selectedItem: item, items });
  };

  handleOnBlur = (e, idx) => {
    const { setHotNotification } = this.context;
    const { items } = this.state;
    if (parseFloat(e.currentTarget.value) < 0) {
      e.currentTarget.value = items[idx].quantity;
      setHotNotification('Qty must be greater than or equal 0');
    }
    if (parseFloat(e.currentTarget.value) <= parseFloat(items[idx].packrow.availableQuantity)) {
      items[idx].quantity = e.currentTarget.value;
      this.setState({ items });
    } else {
      e.currentTarget.value = items[idx].quantity;
      setHotNotification(`Qty must be less than or equal ${items[idx].packrow.availableQuantity}`);
    }
  }

  handleCloseModal = () => {
    const { handleClose } = this.props;
    this.setState({ selectedItem: null, items: [] });
    handleClose();
  }

  handleAddToOrder = () => {
    const { orderId, orderDeliveryDate, updateOrder, readOrder, handleClose } = this.props;
    updateOrder(orderId, { 
      items: this.state.items.filter(item => item.quantity > 0), 
      action: 'addItemToOrder',
      onSuccess: (data) => {
        if (data.isNewDraftCreated) {
          location.href = `/track-orders?delivery_date=${orderDeliveryDate}&order_id=${orderId}`;
        } else {
          data.relatedOrderIds.forEach(
            relatedOrderId => readOrder(relatedOrderId),
          );
        }
        handleClose();
      }
    });
  }

  render() {
    const { isFarmer } = this.context;
    const { open, classes } = this.props;
    let { discount } = this.props;
    discount = parseInt(discount);
    const { selectedItem, items } = this.state;
    const details = isFarmer ? this.props.storeItems.toJS() : this.props.goods.toJS();
    const data = this.getDataWithoutFilter({ details, isFarm: isFarmer });
    return (
      <div>
        <Dialog
          open={open}
          onClose={this.handleCloseModal} 
          aria-labelledby="form-dialog-title"
          PaperProps={{
            classes: {
              root: classes.dialog,
            },
          }}>
          <DialogTitle id="form-dialog-title">
            Add Item
            <IconButton aria-label="Close" className={classes.closeButton} onClick={this.handleCloseModal}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <ItemAutocomplete data={data} handleAddItem={this.handleAddItem} discount={discount} />
            <div>
              {
                selectedItem && !selectedItem.isBulk && (
                  <div>
                    {items.map((item, idx) => (
                      <div key={`${selectedItem.id}-${idx}`}>
                        <div style={{ display: 'flex' }} className="add-item-to-order">
                          <div style={{ display: 'flex', alignItems: 'center', paddingRight: 15 }}>
                            <FRInput
                              autoComplete="off"
                              name="quantity"
                              required
                              defaultValue={item.quantity}
                              onBlur={e => this.handleOnBlur(e, 0)}
                              variant="outlined"
                              inputProps={{
                                style: {
                                  padding: 5,
                                },
                              }}
                              style={{ width: 55, fontSize: 12, marginTop: 0, paddingRight: 5 }}
                              type="number"
                              margin="dense"
                            />
                            <div style={{ color: 'red' }}>{item.packrow.availableQuantity}</div>
                          </div>
                          <div style={{ flexGrow: 1 }}>
                            <Grid container spacing={0} justify="space-between">
                              <Grid item md={6}>
                                <div style={{ fontSize: '11px', wordWrap: 'break-word' }}>
                                  {`${selectedItem.productData.name}, ${selectedItem.productData.subname}`}
                                </div>
                              </Grid>
                              <Grid item md={3}><div style={{ fontSize: '11px', display: 'flex', justifyContent: 'center', fontWeight: 500 }}>{`${item.packrow.count} ${item.packrow.uom} ${item.packrow.pack}`}</div></Grid>
                              <Grid item md={3}><div style={{ fontSize: '11px', display: 'flex', justifyContent: 'flex-end' }}>${(parseFloat(item.packrow.price) * (1 - (discount / 100))).toFixed(2)}{item.quantity ? (<span>&nbsp;&nbsp;&nbsp;=&nbsp;&nbsp;&nbsp;<b>${(item.quantity * (parseFloat(item.packrow.price) * (1 - (discount / 100)))).toFixed(2)}</b></span>) : null}</div></Grid>
                            </Grid>
                            <Grid container spacing={0} justify="space-between">
                              <Grid item md={6}>
                                <div style={{ fontSize: '10px', wordWrap: 'break-word', color: '#5f89b3' }}>
                                  {selectedItem.productData.category}
                                </div>
                              </Grid>
                              <Grid item md={6}><div style={{ fontSize: '10px', color: '#5f89b3', display: 'flex', justifyContent: 'flex-end' }}>{selectedItem.sourcename}</div></Grid>
                            </Grid>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )
              }
              {
                selectedItem && selectedItem.isBulk && (
                  <div>
                    {items.map((item, idx) => (
                      <div key={`${selectedItem.id}-${idx}`}>
                        <div style={{ display: 'flex' }} className="add-item-to-order">
                          <div style={{ display: 'flex', alignItems: 'center', paddingRight: 15 }}>
                            <FRInput
                              autoComplete="off"
                              name="quantity"
                              required
                              defaultValue={item.quantity}
                              onBlur={e => this.handleOnBlur(e, idx)}
                              variant="outlined"
                              inputProps={{
                                style: {
                                  padding: 5,
                                },
                              }}
                              style={{ width: 55, fontSize: 12, marginTop: 0, paddingRight: 5 }}
                              type="number"
                              margin="dense"
                            />
                            <div style={{ color: 'red' }}>{item.packrow.availableQuantity}</div>
                          </div>
                          <div style={{ flexGrow: 1 }}>
                            <Grid container spacing={0} justify="space-between">
                              <Grid item md={2}>{idx === 0 && (<div style={{ fontSize: '11px', display: 'flex', justifyContent: 'center' }}>{`${selectedItem.productData.category}`}</div>)}</Grid>
                              <Grid item md={4}>
                                {
                                  idx === 0 && (
                                    <div style={{ fontSize: '11px', wordWrap: 'break-word' }}>
                                      {`${selectedItem.productData.name}, ${selectedItem.productData.subname}`}
                                    </div>
                                  )
                                }
                                {
                                  idx === 1 && (
                                    <div style={{ fontSize: '11px', wordWrap: 'break-word', color: '#5f89b3' }}>
                                      {`${selectedItem.sourcename}`}
                                    </div>
                                  )
                                }
                              </Grid>
                              <Grid item md={3}><div style={{ fontSize: '11px', display: 'flex', justifyContent: 'center' }}>{`${item.packrow.count} ${item.packrow.uom} ${item.packrow.pack}`}</div></Grid>
                              <Grid item md={3}><div style={{ fontSize: '11px', display: 'flex', justifyContent: 'flex-end' }}>${(parseFloat(item.packrow.price) * (1 - (discount / 100))).toFixed(2)} {item.quantity ? (<span>&nbsp;&nbsp;&nbsp;=&nbsp;&nbsp;&nbsp;<b>${(item.quantity * (parseFloat(item.packrow.price) * (1 - (discount / 100)))).toFixed(2)}</b></span>) : null}</div></Grid>
                            </Grid>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )
              }
            </div>
          </DialogContent>
          <DialogActions classes={{ root: classes.dialogActions }}>
            <Button onClick={this.handleCloseModal} variant="contained" className={classes.cancelBtn}>
              Cancel
            </Button>
            <Button disabled={!(this.state.items.filter(item => item.quantity > 0).length > 0)} onClick={this.handleAddToOrder} color="primary" variant="contained" className={classes.addItemBtn}>
              Add Item To Order
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}


/* istanbul ignore next */
const mapStateToProps = (state, props) => ({
  ...selectState('goods', 'goods')(state, 'goods'),
  ...selectState('storeItems', 'storeItems')(state, 'storeItems'),
});

export default compose(
  setDisplayName('Add Item To Order Modal'),
  withRouter,
  connect(
    mapStateToProps,
    dispatch => ({
      ...dispatchRestMaker([
        [ordersActions, 'order'],
        [contactActions, 'contact'],
        [storeActions, 'storeItem'],
        [goodActions, 'goodItem'],
      ])(dispatch),
    }),
  ),
  withStyles(styles)
)(AddItemToOrderModal);
